import axios from "axios";
import CONSTANTS from "../utils/constants";

export default () => {
  const fetchReviews = () => {
    const hostname = process.env.GATSBY_API_HOSTNAME;
    const token = CONSTANTS.API_TOKEN;
    return axios
      .get(hostname + "/v0/googlemybusiness/reviews", {
        headers: { Authorization: "Bearer " + token },
      })
      .then((res) => {
        return res.data && res.data.data;
      })
      .catch((err) => {
        console.error(err);
        return CONSTANTS.GOOGLE_REVIEWS;
      });
  };

  return { fetchReviews };
};
